export const state = {
    isLoggedIn: false,
    accountUserName: '',
    token:undefined
}

export const mutations = {
    setIsLoggedIn(state, isLoggedIn){
      state.isLoggedIn = isLoggedIn;
    },
    setAccountUserName(state, accountUserName) {
      state.accountUserName = accountUserName;
    },
    setToken(state, token){
      state.token = token;
    }
}

export const getters = {

}

export const actions = {

}
